import React from 'react';
import { YStack } from 'tamagui';
import { Sheet } from 'tamagui';

import CobuText from '../atoms/CobuText';
import CobuLoader from '../atoms/CobuLoader';

interface CobuLoadingOverlayProps {
    visible?: boolean;
    text?: string;
}

const CobuLoadingOverlay: React.FC<CobuLoadingOverlayProps> = ({
    visible = false,
    text,
}) => {
    return (
        <Sheet
            modal
            open={visible}
            onOpenChange={() => {}}
            snapPoints={[100]}
            position={0}
            dismissOnSnapToBottom={false}
            disableDrag
        >
            <Sheet.Overlay bc="rgba(128, 128, 128, 0.5)" />
            <Sheet.Frame bg="transparent">
                <YStack jc="center" ai="center" f={1} bg="transparent" h="100%">
                    <YStack ai="center" gap="$3">
                        <CobuLoader />
                        {text && (
                            <CobuText
                                variant="body"
                                color="$cobuDarkBlue"
                                fontSize="$3"
                                fontWeight={'medium' as any}
                                ta="center"
                            >
                                {text}
                            </CobuText>
                        )}
                    </YStack>
                </YStack>
            </Sheet.Frame>
        </Sheet>
    );
};

export default CobuLoadingOverlay; 